module.exports = __webpack_public_path__ + "img/Maitra logo.b5a28fa9.png";